<template>
  <v-container class="new-back full-height" grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex sm12 class="pb-0">
        <filter-search-input v-model="filters.search" :applied-filters="appliedFilters" outlined dense>
          <q-filter-input
            class="inline-block" label="Customer"
            :items="customers" item-text="name" item-value="id"
            v-model="filters.customer"
            dense outlined hide-details clearable multiple
            :parent-shown-items="customers"
            :data-comparer="(item, value) => item.id == value"
          />
          <q-filter-input
            class="inline-block ml-3" label="Project"
            :items="customerProjects" item-text="name" item-value="id"
            v-model="filters.customerProject"
            dense outlined hide-details clearable multiple
            :parent-shown-items="shownCustomerProjects"
            :data-comparer="(row, projectId) => row.id == projectId"
          />
          <v-autocomplete
            v-model="filters.projectTypes" :items="projectTypes"
            label="Type"
            outlined dense hide-details single-line clearable multiple
            item-text="text" item-value="value"
          />
          <v-autocomplete
            v-model="filters.users" :items="shownUsers"
            label="Delivery Manager"
            dense outlined hide-details clearable multiple
            item-text="blueTag" item-value="id"
          />
          <v-switch class="mt-1" inset label="Only active" v-model="filters.active"></v-switch>
        </filter-search-input>
      </v-flex>
      <v-flex v-show="!view" sm12>
        <v-data-table
          :headers="headers"
          :items="shownCustomerProjects"
          class="rounded-lg bordered new-back lighten2"
          :item-class="() => permissions.detail ? 'cursor-pointer' : ''"
          @click:row="item => permissions.detail ? $router.push(`/admin/projects/${item.id}`) : null"
        >	
          <template #[`item.type`]="{ item }">
            <div
              class="project"
              :style="{background: projectTypes.find(t => t.value == item.type).lightColor}"
            >
              <div
                class="letter"
                :style="{background: projectTypes.find(t => t.value == item.type).color}"
              >
                {{projectTypes.find(t => t.value == item.type).small}}
              </div>
              <div class="name">{{projectTypes.find(t => t.value == item.type).text}}</div>
            </div>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <v-btn
              :color="item.active ? 'green' : 'error'"
              :style="{background: item.active ? '#e1f8dd' : '#f5d0d0'}"
              outlined small style="border-radius: 20px"
            >{{item.active ? 'Active' : 'Inactive'}}</v-btn>
          </template>
        </v-data-table>

      </v-flex>

      <v-flex v-show="view" sm12>
        <project-report/>
      </v-flex>
    </v-layout>
  </v-container>  
  
</template>

<script>
import _ from "lodash"
import BillableJSON from '../../json/billable.json'
import ProjectReport from '../adminSurf/ProjectReport'

export default {
  title: 'Customers',
  props: [],
  components: { ProjectReport },
  data: () => ({
    projectTypes: BillableJSON.projectTypes,
    customers: [],
    headers: [
      { text: "Type", value: "type", align: "start" },
      { text: "Project", value: "name" },
      { text: "Customer", value: "customerName" },
      { text: "Delivery Manager", value: "deliveryManagerBlueTag" },
      { text: "Status", value: "active", align: "center" },
    ],
    vo: {},
    customerProjectTypes: [],
    customerProjects: [],
    view: 0,

    filters: {
      search: '',
      customer: [],
      customerProject: [],
      users: [],
      active: true,
    },
    permissions: {
      detail: false,
      add: false,
      actions: false,
    },
    activeTypes: [
      { value: 1, text: 'Active' },
      { value: 0, text: 'Inactive' },
    ]
  }),
  created() {
		this.customerProjectTypes = BillableJSON.projectTypes

		this.$security.hasRequiredPermission('detail')
			.then(res => this.permissions.detail = res)
		this.$security.hasRequiredPermission('add')
			.then(res => this.permissions.add = res)
		this.$security.hasRequiredPermission('full_access')
			.then(res => this.permissions.actions = res)

    this.$q.log(4, 25, 3, 'NA')
    // this.setUserPreferences('Projects', 'filters')
    document.title = 'Admin Projects'
    this.init();
  },
  computed: {
    /** Proyectos con los mismos filtros que la tabla, excepto el filtro por Delivery Manager (para poblar el combo y poder cambiar de DM sin quitar el filtro). */
    baseFilteredCustomerProjects() {
      let customerProjects = this.customerProjects
      if (this.filters.customer?.length) {
        customerProjects = customerProjects.filter(p => this.filters.customer.includes(p.customerId))
      }
      if (this.filters.customerProject?.length) {
        customerProjects = customerProjects.filter(p => this.filters.customerProject.includes(p.id))
      }
      if (this.filters.projectTypes?.length) {
        customerProjects = customerProjects.filter(p => this.filters.projectTypes.includes(p.type))
      }
      if (this.filters.active) {
        customerProjects = customerProjects.filter(p => p.hasActiveAssignments == this.filters.active)
      }
      if (this.filters.search) {
        let searchResult = this.applySearch(this.filters.search, customerProjects)
        customerProjects = customerProjects
          .filter(p =>
            searchResult.some(r => r.id == p.id) ||
            this.normalizeIncludes(p.name, this.filters.search)
          )
      }
      return customerProjects
    },
    shownCustomerProjects() {
      let customerProjects = this.baseFilteredCustomerProjects
      if (this.filters.users?.length) {
        customerProjects = customerProjects.filter(p =>
          this.filters.users.some(u => u == p.deliveryManagerId)
        )
      }
      return customerProjects
    },
    /** Opciones del filtro DM: todos los managers que aparecen en proyectos bajo los filtros actuales (no limitado a api/user devCenter). */
    shownUsers() {
      const map = new Map()
      for (const p of this.baseFilteredCustomerProjects) {
        if (p.deliveryManagerId == null) continue
        if (!map.has(p.deliveryManagerId)) {
          map.set(p.deliveryManagerId, {
            id: p.deliveryManagerId,
            blueTag: p.deliveryManagerBlueTag || '',
          })
        }
      }
      return _.orderBy([...map.values()], ['blueTag'])
    },
    appliedFilters(){
			return this.countActiveFilters(this.filters, ['search'])
		},
  },
  methods: {
    init() {
      this.$http.get("/api/customer?getInactive=true")
        .then(res => {
          let customers = res.data;
          customers = _.orderBy(customers, ['name']);
          this.customers = customers;
        })
        .catch(res => {
          window.getApp.error("Cannot obtain customers.");
        })

      this.$http.get("/api/CustomerProject/admin")
        .then(res => {
          let customerProjects = res.data
          customerProjects = _.orderBy(customerProjects, ['name']);
          this.customerProjects = customerProjects;
        })
        .catch(res => {
          window.getApp.error("Cannot obtain customer projects.");
        })
    }
  }
}
</script>
<style scoped lang="scss">
  .slider{
    display: inline-block;
    width: auto !important;
    padding: 5px 1px;
  }
  .view-toggle .v-item--active.v-btn:before,
  .v-slide-group .v-slide-item--active.v-btn:before
  {
    background: none !important;
  }
  .colored-back {
    background-color: rgba(22, 123, 215, 0.08) !important;
  }
  .toggle-view {
    height: 40px;
  }
  .inactive {
    color: #999;
  }
  .inactive ::v-deep .v-chip {
    color: #999;
  }
  .default {
    font-weight: 700;
  }
  .v-dialog .v-card {
    padding: 15px;
  }
  .headline {
    width: 100%;
  }
  .input-btn{
    display: grid;
    grid-template-columns: auto 32px;
  }
  
.project{
	display: inline-block;
	border-radius: 15px;
	margin-right: 5px;
	white-space:nowrap;
	div{
		display: inline-flex;
		align-items: center;
		justify-content: center;

	}
	.letter{
		width: 30px;
		padding: 5px;
		color: white;
		border-radius: 15px;
	}
	.name{
		padding: 0 10px 0 5px;
		color: black;
	}
}

.chip{
  background: var(--v-success-)
}
</style> 